import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LogoutConfirmDialogComponent } from '../logout/logout-confirm-dialog/logout-confirm-dialog.component';
import { AuthService } from './auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LogoutService {
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private cookieService: CookieService
  ) { }

  confirmAndLogout(): void {
    const dialogRef = this.dialog.open(LogoutConfirmDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });
  }
}
